import { Chip } from "react-native-paper";
import Box from "../Box";
import { ACCESSIBILITY_LABELS, FILTER_CHIP_DIMENSIONS } from "./constants";

type FilterOption = {
	label: string;
	value: string;
};

type DataCardFilterChipsProps = {
	options: FilterOption[];
	selectedValue?: string;
	onFilterChange?: (value: string) => void;
};

export const DataCardFilterChips = ({
	options,
	selectedValue,
	onFilterChange,
}: DataCardFilterChipsProps) => {
	return (
		<Box
			flexDirection="row"
			flexWrap="wrap"
			justifyContent="center"
			gap={FILTER_CHIP_DIMENSIONS.gap}
			paddingVertical={FILTER_CHIP_DIMENSIONS.verticalPadding}
		>
			{options.map((option) => {
				const isSelected = selectedValue === option.value;
				return (
					<Chip
						key={option.value}
						selected={isSelected}
						compact
						onPress={() => onFilterChange?.(option.value)}
						mode={isSelected ? "flat" : "outlined"}
						accessibilityRole="radio"
						accessibilityState={{ checked: isSelected }}
						accessibilityLabel={ACCESSIBILITY_LABELS.filterChip(option.label)}
					>
						{option.label}
					</Chip>
				);
			})}
		</Box>
	);
};
